import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const deliverables = ['El Protocolo Paso a Paso de 72 horas (Fase de Choque).', 'La lista maestra de Alimentos "Agua" (que sanan) vs. Alimentos "Gasolina" (que inflaman).', 'El sistema de 2 minutos para activar tu drenaje linfático cada mañana.', 'Guía de "Hacks de Sueño" para bajar el cortisol mientras descansas.', 'Rutina post-72 horas para mantenerte desinflamado permanentemente.'];
export const WhatYouGet = () => {
  return <section className="py-20 bg-cream-dark" data-id="element-213">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-216">
            Esto es lo que recibes
          </h2>

          <div className="space-y-4" data-id="element-217">
            {deliverables.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-cream-dark" data-id="element-218">
                <div className="flex-shrink-0" data-id="element-219">
                  <div className="w-8 h-8 rounded-full bg-forest/10 flex items-center justify-center" data-id="element-220">
                    <CheckIcon className="w-5 h-5 text-forest" data-id="element-221" />
                  </div>
                </div>
                <p className="text-charcoal font-medium text-lg" data-id="element-222">{item}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};